module.exports = __webpack_public_path__ + "img/Bingoplus.1ae547a6.webp";